import React from 'react';

export default function Step4HealthInfo({ formData, setFormData, onNext }) {
  const { ActivityLevel, Allergies, MedicalConditions } = formData;

  const isValid = ActivityLevel !== null && Allergies !== null && MedicalConditions !== null;

  return (
    <div className="space-y-6">
      <h2 className="text-lg font-bold mb-4">اطلاعات سلامتی و تغذیه</h2>

      {/* سطح فعالیت روزانه */}
      <div>
        <label className="block text-sm mb-1">سطح فعالیت روزانه:</label>
        <select
          value={ActivityLevel ?? ''}
          onChange={(e) => setFormData({ ...formData, ActivityLevel: parseInt(e.target.value) })}
className="w-full p-3 rounded-xl border-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-600 bg-white dark:bg-[#2a2f3b] transition"
        >
          <option value="">انتخاب کنید...</option>
          <option value="0">کم</option>
          <option value="1">متوسط</option>
          <option value="2">زیاد</option>
        </select>
      </div>

      {/* آلرژی */}
      <div>
        <label className="block text-sm mb-1">آلرژی غذایی:</label>
        <select
          value={Allergies ?? ''}
          onChange={(e) => setFormData({ ...formData, Allergies: parseInt(e.target.value) })}
className="w-full p-3 rounded-xl border-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-600 bg-white dark:bg-[#2a2f3b] transition"
        >
          <option value="">انتخاب کنید...</option>
          <option value="0">هیچ‌کدام</option>
          <option value="1">گلوتن</option>
          <option value="2">لبنیات</option>
          <option value="3">آجیل</option>
          <option value="4">تخم‌مرغ</option>
        </select>
      </div>

      {/* بیماری یا شرایط پزشکی */}
      <div>
        <label className="block text-sm mb-1">شرایط پزشکی:</label>
        <select
          value={MedicalConditions ?? ''}
          onChange={(e) => setFormData({ ...formData, MedicalConditions: parseInt(e.target.value) })}
className="w-full p-3 rounded-xl border-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-600 bg-white dark:bg-[#2a2f3b] transition"
        >
          <option value="">انتخاب کنید...</option>
          <option value="0">هیچ‌کدام</option>
          <option value="1">دیابت</option>
          <option value="2">فشار خون</option>
          <option value="3">بیماری قلبی</option>
          <option value="4">مشکلات مفصلی</option>
        </select>
      </div>

      <div className="text-right">
        <button
          onClick={onNext}
          disabled={!isValid}
          className="w-full p-3 bg-blue-600 rounded-xl border-2 hover:bg-blue-700 text-white px-6 py-2 rounded-xl disabled:opacity-50"
        >
          مرحله بعد
        </button>
      </div>
    </div>
  );
}
